import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { assets, contactInfo } from '../../data/events';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <motion.header 
      data-testid="header"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="absolute top-0 left-0 z-50 pointer-events-none"
    >
      <div className="flex items-start p-2 md:p-6">
        {/* Logo - Mobile only, compact */}
        <motion.div 
          data-testid="header-logo"
          className="pointer-events-auto md:hidden"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <a 
            href={`https://${contactInfo.website}`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="block"
          >
            <img 
              src={assets.logo} 
              alt={contactInfo.name}
              className="w-12 h-12 rounded-full shadow-lg object-cover bg-white"
            />
          </a>
        </motion.div>
      </div>

      {/* Mobile Menu Button - Now inside the SearchAndFilters component */}
      
      {/* Mobile Menu */}
      {isMenuOpen && (
        <motion.div
          data-testid="mobile-menu"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="md:hidden absolute top-20 left-4 right-4 glass rounded-2xl p-6 shadow-xl pointer-events-auto"
        >
          <h1 className="font-league text-2xl uppercase tracking-wide text-black">
            Où nous trouver ?
          </h1>
          <p className="font-dm text-sm text-[#666666] mt-1 mb-4">
            {contactInfo.slogan}
          </p>
          <div className="border-t border-gray-200 pt-4 space-y-2">
            <a 
              href={`tel:${contactInfo.phone}`}
              className="block font-dm text-sm text-[#666666] hover:text-black transition-colors"
            >
              📞 {contactInfo.phone}
            </a>
            <a 
              href={`mailto:${contactInfo.email}`}
              className="block font-dm text-sm text-[#666666] hover:text-black transition-colors"
            >
              ✉️ {contactInfo.email}
            </a>
            <a 
              href={`https://instagram.com/${contactInfo.instagram.replace('@', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block font-dm text-sm text-[#666666] hover:text-black transition-colors"
            >
              📸 {contactInfo.instagram}
            </a>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};
